import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Excluir posição", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-normal" }, [
  /*#__PURE__*/_createTextVNode(" Tem certeza que deseja excluir a posição?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Essa ação não poderá ser desfeita! ")
], -1)
const _hoisted_3 = { class: "flex justify-center gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_filled_button = _resolveComponent("filled-button")!
  const _component_outline_button = _resolveComponent("outline-button")!
  const _component_modal_vue = _resolveComponent("modal-vue")!

  return (_openBlock(), _createBlock(_component_modal_vue, {
    onClose: $setup.handleToggleModal,
    modalActive: $setup.modals[$setup.modalName]
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_filled_button, {
          width: "119px",
          onClick: $setup.handleToggleModal,
          text: "Cancelar"
        }, null, 8, ["onClick"]),
        _createVNode(_component_outline_button, {
          disabled: $setup.isLoading,
          loading: $setup.isLoading,
          text: "Excluir",
          width: "119px",
          onClick: $setup.handleRemove
        }, null, 8, ["disabled", "loading", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _hoisted_2
    ]),
    _: 1
  }, 8, ["onClose", "modalActive"]))
}